import { type CustomerSummary } from '~/shell/api/rtk/generated'

/**
 * The customer a session falls back to when it has expressed no preference of its own.
 *
 * Demo rather than first-in-list: the list is ordered by display name, so first-in-list is an
 * alphabetical accident that lands a fresh session on real patient data. Demo carries curated sample
 * data instead.
 */
export const DEMO_CUSTOMER_REGARD_ID = 'demo'

/**
 * Which customer to land a session on, given the customers it may reach: the preferred one, else Demo,
 * else the first accessible.
 *
 * The order is preference, not permission — every candidate is checked against `customers`, so a stored
 * value naming a customer the session has lost access to is skipped rather than trusted. `undefined`
 * for an empty list, which the caller turns into the no-access page.
 */
export const resolveLandingCustomer = (
  customers: CustomerSummary[],
  preferredCustomer: string | null,
): string | undefined => {
  const isAccessible = (candidate: string): boolean =>
    customers.some((customer) => customer.customerRegardId === candidate)

  if (preferredCustomer !== null && isAccessible(preferredCustomer)) {
    return preferredCustomer
  }

  if (isAccessible(DEMO_CUSTOMER_REGARD_ID)) {
    return DEMO_CUSTOMER_REGARD_ID
  }

  return customers[0]?.customerRegardId
}
